import { render, staticRenderFns } from "./AbroadHuiyiDetails.vue?vue&type=template&id=27528571&scoped=true"
import script from "./AbroadHuiyiDetails.vue?vue&type=script&lang=js"
export * from "./AbroadHuiyiDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27528571",
  null
  
)

export default component.exports